import dayjs from "dayjs";

export const buildLinkFromFilter = (tripType, origin, dest, start, end, min, max, lang) => {
  const linkUrl =
    `/cheap-flights/${tripType}/${origin}` +
    (dest ? `/${dest}` : "") +
    (start ? `/${dayjs.unix(start).format("YYYY-MM-DD")}` : "") +
    (end ? `/${dayjs.unix(end).format("YYYY-MM-DD")}` : "") +
    `?lang=${lang}` +
    ([min, max].some(Boolean)
      ? `&${[min, max]
          .reduce((acc, p, i) => {
            if (!p) return acc;
            acc.push(i === 0 ? `min=${p}` : `max=${p}`);
            return acc;
          }, [])
          .join("&")}`
      : "");
  return linkUrl;
};

export function formatFlightDate(timestampSeconds, lang) {
  const date = new Date(timestampSeconds * 1000);
  const options = {
    day: "2-digit",
    month: "short",
  };
  const formattedDate = new Intl.DateTimeFormat(lang, options).format(date);
  return formattedDate;
}
